"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 所有的 plot theme object，每个图类型只会存在一个 theme
 */
var PLOT_THEME_MAP = {};
/**
 * 注册新的图表主题
 * @param type
 * @param theme
 */
function registerTheme(type, theme) {
    PLOT_THEME_MAP[type.toLowerCase()] = theme;
}
exports.registerTheme = registerTheme;
/**
 * 根据类型获取主题
 * @param type
 */
function getTheme(type) {
    return PLOT_THEME_MAP[type.toLowerCase()] || {};
}
exports.getTheme = getTheme;
//# sourceMappingURL=theme.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/theme/theme.js
// module id = 1021
// module chunks = 37